'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
require('../../../core/Testimonial/TestimonialInEdit.js');
var Theme = require('../../../Theme/Theme.js');
require('../../../Theme/DarkTheme.js');
require('../../../Theme/LightTheme.js');
require('prop-types');
var createMuiTheme = require('../../../node_modules/@material-ui/core/esm/styles/createMuiTheme.js');
var Chip$1 = require('../../../node_modules/@material-ui/core/esm/Chip/Chip.js');
var ThemeProvider = require('../../../node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var SUCCESS_COLOR = "success";
var ERROR_COLOR = "error";

var Chip = function Chip(_ref) {
  var color = _ref.color,
      props = objectWithoutProperties(_ref, ["color"]);

  if (color === SUCCESS_COLOR) {
    return React__default["default"].createElement(ThemeProvider, {
      theme: successTheme
    }, React__default["default"].createElement(Chip$1["default"], _extends["default"]({
      color: "primary"
    }, props)));
  }

  if (color === ERROR_COLOR) {
    return React__default["default"].createElement(ThemeProvider, {
      theme: errorTheme
    }, React__default["default"].createElement(Chip$1["default"], _extends["default"]({
      color: "primary"
    }, props)));
  }

  return React__default["default"].createElement(Chip$1["default"], _extends["default"]({
    color: color
  }, props));
};

var successTheme = createMuiTheme(_objectSpread({}, Theme.theme, {
  palette: {
    primary: {
      main: Theme.theme.palette.success.main,
      contrastText: Theme.theme.palette.white.primary
    }
  }
}));
var errorTheme = createMuiTheme(_objectSpread({}, Theme.theme, {
  palette: {
    primary: {
      main: Theme.theme.palette.error.main,
      contrastText: Theme.theme.palette.white.primary
    }
  }
}));
Chip.defaultProps = {
  color: "default"
};

module.exports = Chip;
